import React from 'react';
import css from './SectionGuarantee.module.css';

const SectionGuarantee = () => (
  <section className={css.root}>
    <div className={css.container}>
      <div className={css.badge}>The First Session Promise</div>
      <h2 className={css.title}>Not happy with your first session? We'll make it right.</h2>
      <p className={css.body}>
        If your first booking doesn't meet your expectations, contact us within 24 hours.
        We'll issue a full refund or match you with a better-fit trainer — no questions asked.
      </p>
      <div className={css.points}>
        <div className={css.point}>
          <svg aria-hidden="true" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#0BB8FC" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="20 6 9 17 4 12" />
          </svg>
          Full refund on your first session
        </div>
        <div className={css.point}>
          <svg aria-hidden="true" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#0BB8FC" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="20 6 9 17 4 12" />
          </svg>
          Free rematch with a different trainer
        </div>
        <div className={css.point}>
          <svg aria-hidden="true" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#0BB8FC" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="20 6 9 17 4 12" />
          </svg>
          No membership. No fine print.
        </div>
      </div>
      <a href="/p/first-session-promise" className={css.link}>Read the full promise →</a>
    </div>
  </section>
);

export default SectionGuarantee;
